<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Work Requests" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'create_job' }" class="btn btn-primary float-end">Create Work</router-link>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchJobRequests()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @keyup="fetchJobRequests()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Customer</th>
											<th>Location</th>
											<th>Product & Work Type</th>
											<th>Requested Technician</th>
											<th>Date</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(job_requests.length)">
										<tr align="center" v-for="(request, index) in job_requests" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
											<td>
												{{ request.customer_name }}<br>
												+91 {{ request.mobile }}
											</td>
											<td>{{ request.location }}</td>
											<td>
												{{ request.product_name }} 
												<br> 
												<span v-if="request.service_type == 1">New</span>
												<span v-else-if="request.service_type == 2">Repair</span>
												<span v-else>Replacement</span>
											</td>
											<td>{{ request.name }}</td>
											<td>{{ proxy.$filters.convertDate(request.date) }}</td>
                                            <td>
                                                <button class="btn btn-success btn-sm me-2 mb-2" @click="openModal(request.id)">Approve</button>
                                            </td>
                                        </tr>        
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" class="text-center">No work requests found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
									<a class="page-link" href="#" @click.prevent="fetchJobRequests(page.url)" tabindex="-1">
										<span v-if="index === 0">Prev</span>
										<span v-else-if="index === pagination.length - 1">Next</span>
										<span v-else v-html="page.label"></span>
									</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Amount<span class="text-danger">*</span></label>
						    <input class="form-control" type="text" placeholder="Enter Amount" v-model="amount"/>
							<span class="validate-error" v-if="errors.amount">
								{{ errors.amount[0] }}
							</span>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" @click="approveRequest()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>


	</div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
import { get, post } from '@/utils/api';
import { routes } from '@/constants/routes';
import { useRouter } from 'vue-router';
import Swal from '@/utils/swal';

let dynamicmodal = null;

const router = useRouter();
const { proxy } = getCurrentInstance();

const listing_length = ref(10);
const keyword = ref("");
const modal_title = ref("Approve Request");
const button_title = ref("Save");
const errors = ref({});
const job_requests = ref([]);
const job_id = ref("");
const amount = ref("");
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

const showModal = () => {
    if (dynamicmodal) dynamicmodal.show();
};

const hideModal = () => {
    if (dynamicmodal) dynamicmodal.hide();
};

const closeModal = () => {
    hideModal();
};

const openModal = (id) => {
    errors.value = {};
	job_id.value = id;
    showModal();
};

const fetchJobRequests = (url = null) => {

	const params = {
		limit: listing_length.value,
		keyword: keyword.value
	}

	const requestUrl = url ?? routes.WorkRequests;

	get(requestUrl, { params }, false)
		.then((response) => {
			if(response.status === 200){
				console.log(response.data.data);
				job_requests.value = response.data.data.data;
				pagination.value = response.data.data.links;
				from.value = response.data.data.from;
				to.value = response.data.data.to;
				total.value = response.data.data.total;
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch job requests', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.limit?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
            }
		});
};

const approveRequest = () => {

	const formData = new FormData();
	formData.append('job_id', job_id.value);
	formData.append('amount', amount.value);

	post(routes.AcceptWork, formData, false)
		.then((response) => {
			if(response.status === 200){
				closeModal();
				Swal.fire('', response.data.message || 'Work accepted successfully', 'success');
				router.push({ name: 'job_management'});
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch job', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                errors.value = error.response.data.message;
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
            }
		});

};

onMounted(() => {
	fetchJobRequests();
    dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
});

</script>